const SaveIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M0 0V13.75H13.75V2.87109L13.5742 2.67578L11.0742 0.175781L10.8789 0H0ZM1.25 1.25H3.125V5H10.625V1.52344L12.5 3.39844V12.5H11.25V6.875H2.5V12.5H1.25V1.25ZM4.375 1.25H6.875V2.5H8.125V1.25H9.375V3.75H4.375V1.25ZM3.75 8.125H10V12.5H3.75V8.125Z"
        fill="var(--surface-hover)"
      />
    </svg>
  );
};

export default SaveIcon;
